import {
    Box,
    CircularProgress,
    CircularProgressLabel,
    Flex,
    Spinner,
    Text,
} from "@chakra-ui/react";
import WidgetBox from "components/elements/WidgetBox/widget-box";
import { ChecklistStatus, getLastStatus } from "hooks/useChecklist";
import { ChecklistContext } from "providers/checklist";
import { useContext, useEffect, useState } from "react";

const LoanTargetBox = () => {
    const { grouped = [], isLoading } = useContext(ChecklistContext);
    const [progress, setProgress] = useState(0);
    const [completed, setCompleted] = useState(0);
    const [totalItems, setTotalItems] = useState(0);

    useEffect(() => {
        if (!grouped || !Array.isArray(grouped) || grouped.length === 0) {
            return;
        }

        // Flatten all items from all categories
        const allVisibleItems = grouped.flatMap(
            (category: any) => category.items || []
        );

        // Count total visible items
        setTotalItems(allVisibleItems.length);

        // Count approved items
        const approvedItems = allVisibleItems.filter((item: any) => {
            const lastStatus = getLastStatus(item.loan_item_status);
            return lastStatus?.status === ChecklistStatus.Approved;
        });

        setCompleted(approvedItems.length);

        // Calculate progress percentage
        if (allVisibleItems.length > 0) {
            setProgress(
                Math.round(
                    (approvedItems.length / allVisibleItems.length) * 100
                )
            );
        } else {
            setProgress(0);
        }
    }, [grouped]);

    if (isLoading) return <Spinner />;

    if (!grouped || !Array.isArray(grouped) || grouped.length === 0)
        return null;

    return (
        <Box flex="1" minW="300px" maxW="400px">
            <WidgetBox title="Checklist Status Progress">
                <Flex direction="column" gap={4} alignItems="center">
                    <Flex gap={2} alignItems="center">
                        <Box>
                            <CircularProgress
                                value={progress}
                                color="#45C14A"
                                thickness="6px"
                                size="98px"
                            >
                                <CircularProgressLabel
                                    fontWeight="500"
                                    fontSize="26px"
                                >
                                    {!Number.isNaN(progress) ? progress : 0}%
                                </CircularProgressLabel>
                            </CircularProgress>
                        </Box>
                        <Flex direction="column" alignItems="center">
                            <Text as="h3" color="#302E34">
                                Approved Checklist Items
                            </Text>
                            <Text color="#171B1E" fontWeight="700" fontSize="30px">
                                {completed} / {totalItems}
                            </Text>
                        </Flex>
                    </Flex>
                    <Text fontSize="14px">
                        <Text as="span" color="#FC2E53">
                            {totalItems - completed}
                        </Text>{" "}
                        checklist items left to approve
                    </Text>
                </Flex>
            </WidgetBox>
        </Box>
    );
};

export default LoanTargetBox;
